/** Token key → CSS variable helpers (primitives only). */
import type { ColorToken, FontToken, RadiusToken, SizeToken, SpaceToken, WeightToken } from "@bundle/tokens";

export const color = (k: ColorToken) => `var(--b-color-${k.replace(/\./g, "-")})`;
export const space = (k: SpaceToken) => `var(--b-space-${k.replace(".", "_")})`;
export const radius = (k: RadiusToken) => `var(--b-radius-${k})`;
export const size = (k: SizeToken) => `var(--b-size-${k.replace(/\./g, "-")})`;
export const fontSize = (k: FontToken) => `var(--b-font-size-${k})`;
export const lineHeight = (k: FontToken) => `var(--b-line-height-${k})`;
export const fontWeight = (k: WeightToken) => `var(--b-font-weight-${k})`;

/** Joins truthy class names. */
export function cx(...names: (string | false | undefined | null)[]): string {
  return names.filter(Boolean).join(" ");
}

export type { ColorToken, FontToken, RadiusToken, SizeToken, SpaceToken, WeightToken };
